import React from 'react';
import { ModalComponent } from '../shared/modal-component/ModalComponent';
import styles from './styles.module.scss';
import classNames from 'classnames';
import mainStyles from '../../styles.module.scss';
import { CCMClientSettingsConfig } from '../../config/CCMClientSettingsConfig';

export const SyncStatusModalComponent = ({ title, isOpen, modalActions }) => {
  const { CONFIRM_SUBMIT } = CCMClientSettingsConfig;
  const { submitClick, closeModal } = modalActions;

  return (
    <ModalComponent title={title} isOpen={isOpen} notifyOfClose={closeModal}>
      <div className={classNames(styles.modalContainer)}>
        <div>
          <h2>validation in progress. Are you sure you want to submit?</h2>
        </div>
        <div className={classNames(styles.buttonContainer)}>
          <button
            className={classNames('mr-1', mainStyles.regularBtn, { [styles.actionBtn]: true })}
            onClick={() => {
              closeModal();
              submitClick({ action: CONFIRM_SUBMIT });
            }}
          >
            Submit
          </button>
          <button
            className={classNames(mainStyles.regularBtn, { [styles.actionBtn]: true, [styles.cancelBtn]: true })}
            onClick={() => {
              closeModal();
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </ModalComponent>
  );
};
